export const isProdaOrJllUser = (
    user: { email?: string | null } | null | undefined,
): boolean => {
    if (typeof user?.email !== "string") return false;

    return user.email.endsWith("@proda.ai") || user.email.endsWith("@jll.com");
};
